import React from 'react';
import { useTranslation } from 'utils/i18n';
import { colors, notice } from './docsStyles';
import DocsNotice from './DocsNotice';

/**
 * DocsBindingNotice
 * Displays a notice that the German version is legally binding
 * Only shown when current language is not German
 */
const DocsBindingNotice = () => {
  const { language } = useTranslation();

  // Only show notice for non-German languages
  if (language === 'de') {
    return null;
  }

  // Get German URL path
  const getGermanPath = () => {
    const currentPath = window.location.pathname;
    // If already German, return as-is
    if (currentPath.startsWith('/de/')) {
      return currentPath;
    }
    // Replace language prefix with /de/ or add /de/ if no language prefix exists
    if (currentPath.match(/^\/[a-z]{2}\//)) {
      return currentPath.replace(/^\/[a-z]{2}\//, '/de/');
    }
    // No language prefix, add /de/
    return `/de${currentPath === '/' ? '' : currentPath}`;
  };

  const translations = {
    en: {
      heading: 'Legal Notice',
      text: 'The legally binding version of these Terms and Conditions is the German version. This translation is provided for convenience only and has no legal effect. In case of any discrepancies, the German version shall prevail.',
      linkText: 'View German version'
    },
    es: {
      heading: 'Aviso Legal',
      text: 'La versión legalmente vinculante de estos Términos y Condiciones es la versión alemana. Esta traducción se proporciona únicamente para conveniencia y no tiene efecto legal. En caso de discrepancias, prevalecerá la versión alemana.',
      linkText: 'Ver versión alemana'
    },
    id: {
      heading: 'Pemberitahuan Hukum',
      text: 'Versi yang mengikat secara hukum dari Syarat dan Ketentuan ini adalah versi Jerman. Terjemahan ini disediakan hanya untuk kenyamanan dan tidak memiliki efek hukum. Jika ada perbedaan, versi Jerman yang berlaku.',
      linkText: 'Lihat versi Jerman'
    }
  };

  const t = translations[language] || translations.en;

  const linkStyle = {
    ...notice.link,
    color: colors.link
  };

  return (
    <DocsNotice type="info" heading={t.heading}>
      {t.text}{' '}
      <a href={getGermanPath()} style={linkStyle}>
        {t.linkText}
      </a>
    </DocsNotice>
  );
};

export default DocsBindingNotice;




